export default "__VITE_ASSET__CTxknDDc__"